import { render, staticRenderFns } from "./sm.vue?vue&type=template&id=4cc46d50&scoped=true&"
import script from "./sm.vue?vue&type=script&lang=js&"
export * from "./sm.vue?vue&type=script&lang=js&"
import style0 from "./sm.vue?vue&type=style&index=0&id=4cc46d50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc46d50",
  null
  
)

export default component.exports